import { render, staticRenderFns } from "./ModalLuxInfo.vue?vue&type=template&id=c4b32a5c&scoped=true"
import script from "./ModalLuxInfo.vue?vue&type=script&lang=js"
export * from "./ModalLuxInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxInfo.vue?vue&type=style&index=0&id=c4b32a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b32a5c",
  null
  
)

export default component.exports